import { render, staticRenderFns } from "./CustomerIssueGift.vue?vue&type=template&id=23fa50ef&scoped=true&"
import script from "./CustomerIssueGift.vue?vue&type=script&lang=js&"
export * from "./CustomerIssueGift.vue?vue&type=script&lang=js&"
import style0 from "./CustomerIssueGift.vue?vue&type=style&index=0&id=23fa50ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23fa50ef",
  null
  
)

export default component.exports